module.exports = __webpack_public_path__ + "media/images/assinatura_dr_alex-800f6301434a42702fd8717ebf1318aa.png";